import { render, staticRenderFns } from "./InvitationStatusTag.vue?vue&type=template&id=87a40f2e&scoped=true&"
import script from "./InvitationStatusTag.vue?vue&type=script&lang=js&"
export * from "./InvitationStatusTag.vue?vue&type=script&lang=js&"
import style0 from "./InvitationStatusTag.vue?vue&type=style&index=0&id=87a40f2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a40f2e",
  null
  
)

export default component.exports